import { z } from 'zod';

export const activeAnnouncementSchema = z.object({
    id: z.uuid(),
    notificationType: z.string(),
});

export type ActiveAnnouncement = z.infer<typeof activeAnnouncementSchema>;

export const activeAnnouncementsResponseSchema = z.array(activeAnnouncementSchema);

export const announcementHistoryItemSchema = z.object({
    createdAt: z.iso.datetime(),
    dismissed: z.boolean(),
    id: z.uuid(),
    notificationType: z.string(),
});

export type AnnouncementHistoryItem = z.infer<typeof announcementHistoryItemSchema>;

export const announcementHistoryResponseSchema = z.array(announcementHistoryItemSchema);
